<template>
  <div>
    <span
      v-if="isOnline"
      class="status-bubble status-bubble--online bg-success"
      >{{ onlineText }}</span
    >
    <span v-else class="status-bubble status-bubble--offline">{{
      offlineText
    }}</span>
  </div>
</template>
<script lang="babel">
export default {
    props: {
       isOnline: {
           required: false,
           type: Boolean,
           default: false
       },
       onlineText: {
           required: false,
           type: String,
           default: "Online!"
       },
       offlineText: {
           required: false,
           type: String,
           default: "Offline!"
       }
    },
  };
</script>
